import styles from './MainLogo.module.css'
import logoImage from '../../assets/images/white-3m.png'

function MainLogo() {
  return (
    <div className={styles.container}>
      <img className={styles.image} src={logoImage} alt="Logo" />
    </div>
  )
}

export default MainLogo
